<rb-loading-spinner *ngIf="dataLoadingSoc" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessageSoc && !dataLoadingSoc">
    <rb-callout type="warning">
        No data for "End State of Charge" chart.
    </rb-callout>
</div>
<div id="end-state-of-charge-ef-chart"></div>
<div class="p-2" *ngIf="!dataLoadingSoc && !errorMessageSoc">
    <div class="shaded-container ">
        Distribution of the final state of charge per charging event along with the corresponding value(s) of the selected vehicle(s). The frequencies are determined from all charging phases of all vehicles in the fleet.
    </div>
</div>